import values from 'ramda/src/values';
import path from 'ramda/src/path';
import pipe from 'ramda/src/pipe';
import propOr from 'ramda/src/propOr';
import reject from 'ramda/src/reject';
import map from 'ramda/src/map';
import isNil from 'ramda/src/isNil';

const mapAndFilter = state => pipe(
  map(id => state.services.byId[id]),
  reject(isNil)
);

export const getAll = state => mapAndFilter(state)(state.services.list);

export const getById = (state, id) => state.services.byId[id];

export const getByIds = (state, ids) => mapAndFilter(state)(ids);

const servicesObject = path(['services', 'byId']);

export const forAppointmentForm = pipe(servicesObject, values);

const durationProp = propOr(null, 'duration');
export const getServiceDuration = pipe(getById, durationProp);
